export const GiftTypes = [
  {
    id: 'GIFT_TYPE_UNKNOWN',
    name: 'Не указан',
  },
  {
    id: 'GIFT_TYPE_NON_MATERIAL',
    name: 'Подарок по электронной почте',
  },
  {
    id: 'GIFT_TYPE_NON_MATERIAL_DELIVERY_PHONE',
    name: 'Подарок по номеру телефона',
  },
  {
    id: 'GIFT_TYPE_MATERIAL_DELIVERY_POST',
    name: 'Материальный подарок с доставкой',
  },
  {
    id: 'GIFT_TYPE_MATERIAL_DELIVERY_POST_CLOTHES_SIZE',
    name: 'Одежда',
  },
  {
    id: 'GIFT_TYPE_CONVERSION_CROWNS_USD',
    name: 'Обмен корон на валюту',
  },
  {
    id: 'GIFT_TYPE_BONUS_CROWNS_REVIEW_SCREENSHOT',
    name: 'Отзыв за 2 короны',
  },
  {
    id: 'GIFT_TYPE_MERCH_TEMPLATES',
    name: 'Merch Templates',
  },
]
